import { ClientOrganizationCreateRequestTagsEnum } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { LocalizationNameSpace } from '@/localization/types/localizationTypes';

/** Options for a select/dropdown representing an organization tag. */
export type OrganizationTagOption = {
  label: string;
  value: ClientOrganizationCreateRequestTagsEnum;
};

/**
 * Maps the organization types the caller may create into labeled select
 * options. Only tags contained in `creatableTypes` are returned; labels are
 * resolved from the organization tag-label translations.
 *
 * @param creatableTypes - Array of tag enums the user is allowed to create, or undefined
 * @returns Array of {label, value} objects for dropdown/select components
 */
export const useMapOrganizationTagToOptions = (
  creatableTypes: ClientOrganizationCreateRequestTagsEnum[] | undefined
): OrganizationTagOption[] => {
  const { t: tTags } = useTranslation(LocalizationNameSpace.ORGANIZATION, {
    keyPrefix: 'organization'
  });

  return useMemo(
    () =>
      Object.values(ClientOrganizationCreateRequestTagsEnum)
        .filter((value) => creatableTypes?.includes(value))
        .map((value) => ({
          label: tTags(`tagLabels.${value}`),
          value
        })),
    [creatableTypes, tTags]
  );
};
